import QuantModelListPage from "./QuantModelListPage";

export default QuantModelListPage;
